import { Link } from "@tanstack/react-router";
import { AboutBox } from "../design/components/AboutBox";
import { Reason } from "../design/components/Reason";
import { SettingsLayout } from "../design/components/SettingsLayout";
import { StatusPill } from "../design/components/StatusPill";
import { useT } from "../i18n/locale";
import { useAccess, type Access } from "../session/access";
import { FileImportButton } from "./FileImportButton";
import "./import-export.css";

// Impostazioni → «Importazione ed esportazione» (richiesta del product owner del 1° ottobre 2026): i modi per far entrare i
// Lead in Gioia365 e farli uscire. L'«Importazione guidata da Close» resta la pagina del piano M2 Task 21,
// uguale dentro); M6 R6 apre il CSV nella finestra comune anche all'elenco Lead. Excel passa dal CSV (D20).
// Accanto, «GoHighLevel» (INGR-29, 24/10/2026): la chiave di sola lettura e la prova di lettura. L'esportazione resta «in arrivo». La sezione segue import_leads; le scritture non sono offerte nella Vista Commerciale.

/** Come la voce del menu (`SettingsLayout`) e come la pagina di Close: con `import_leads`, o dalla piattaforma. */
function canSeeImportExport(access: Access): boolean {
  return access.isPlatform || access.can("import_leads");
}

export function ImportExportPage() {
  return (
    <SettingsLayout section="importExport">
      <ImportExportSection />
    </SettingsLayout>
  );
}

function ImportExportSection() {
  const t = useT();
  const access = useAccess();
  const organization = access.context.organization.name;
  return (
    <div className="g-ie">
      <AboutBox title={t("importExport.about.title")}>
        <p>{t("importExport.about.text")}</p>
        <h2>{t("importExport.about.whoTitle")}</h2>
        <p>{t("importExport.about.who", { organization })}</p>
      </AboutBox>
      {canSeeImportExport(access) ? <Ways /> : <Reason>{t("importExport.denied", { organization })}</Reason>}
    </div>
  );
}

function Ways() {
  const t = useT();
  return (
    <ul className="g-ie__ways" aria-label={t("importExport.ways")}>
      <li className="g-ie__way">
        <h2>{t("importExport.close.title")}</h2>
        <p>{t("importExport.close.text")}</p>
        <div>
          <Link to="/impostazioni/importazione-ed-esportazione/close" className="g-button" data-variant="primary">
            {t("importExport.close.open")}
          </Link>
        </div>
      </li>
      <li className="g-ie__way">
        <h2>{t("importExport.ghl.title")}</h2>
        <p>{t("importExport.ghl.text")}</p>
        <div>
          <Link to="/impostazioni/importazione-ed-esportazione/gohighlevel" className="g-button">
            {t("importExport.ghl.open")}
          </Link>
        </div>
      </li>
      <li className="g-ie__way">
        <h2>{t("importExport.file.title")}</h2>
        <p>{t("importExport.file.text")}</p>
        <div><FileImportButton /></div>
      </li>
      <li className="g-ie__way">
        <div className="g-ie__way-head">
          <h2>{t("importExport.export.title")}</h2>
          <StatusPill tone="neutral" icon="clock">
            {t("importExport.later")}
          </StatusPill>
        </div>
        <p>{t("importExport.export.text")}</p>
        <p className="g-ie__muted">{t("importExport.export.when")}</p>
      </li>
    </ul>
  );
}
